var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsGraphAnxietyWorry(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.696 40.507.953.345a2.034 2.034 0 0 1 1.218 2.612l-3.47 9.47a2.034 2.034 0 0 1-2.602 1.214l-.952-.345a2.034 2.034 0 0 1-1.218-2.612l3.47-9.47a2.034 2.034 0 0 1 2.601-1.214z",
    fill: "#5AA0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.988 45.28.953.344a2.034 2.034 0 0 1 1.218 2.612l-7.644 20.862a2.034 2.034 0 0 1-2.6 1.213l-.954-.344a2.034 2.034 0 0 1-1.218-2.612l7.644-20.863a2.034 2.034 0 0 1 2.601-1.213z",
    fill: "#3A6CD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.842 39.801.952.345a2.034 2.034 0 0 1 1.219 2.612l-5.21 14.218a2.034 2.034 0 0 1-2.6 1.213l-.953-.345a2.034 2.034 0 0 1-1.219-2.612l5.21-14.218a2.034 2.034 0 0 1 2.6-1.213z",
    fill: "#BDD9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.124 35.163c-.96 0-1.705-.928-1.586-1.977.884-7.778 6.915-13.797 14.225-13.797s13.34 6.019 14.224 13.797c.12 1.05-.626 1.977-1.586 1.977H43.124z",
    fill: "#AAAAAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.247 35.205c-1.23 0-2.184-1.19-2.031-2.533C20.348 22.71 28.073 15 37.436 15c9.361 0 17.086 7.71 18.219 17.672.152 1.344-.802 2.533-2.032 2.533H21.247z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.204 35.147c-.723 0-1.285-.7-1.195-1.49.667-5.86 5.21-10.395 10.718-10.395 5.507 0 10.051 4.535 10.717 10.396.09.79-.471 1.49-1.195 1.49H11.204z",
    fill: "#AAAAAC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsGraphAnxietyWorry);
export default __webpack_public_path__ + "static/media/icons_graph_anxiety_worry.5efeda722a1e3a98d7e1ade3b9adafcc.svg";
export { ForwardRef as ReactComponent };